/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Reactions,
} from '../models';
import {
    ReactionsFromJSON,
    ReactionsToJSON,
} from '../models';

export interface BulkGetReactionsRequest {
    reactedToIds: Array<string>;
    type?: string;
}

/**
 * 
 */
export class ReactionsApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Gets reactions by reacted_to_id and type
     */
    async bulkGetReactionsRaw(params: BulkGetReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reactions>> {
        if (params.reactedToIds === null || params.reactedToIds === undefined) {
            throw new runtime.RequiredError('reactedToIds','Required parameter params.reactedToIds was null or undefined when calling bulkGetReactions.');
        }

        const queryParameters: any = {};

        if (params.type !== undefined) {
            queryParameters['type'] = params.type;
        }

        if (params.reactedToIds) {
            queryParameters['reacted_to_ids'] = params.reactedToIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionsFromJSON(jsonValue));
    }

    /**
     * Gets reactions by reacted_to_id and type
     */
    async bulkGetReactions(params: BulkGetReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reactions> {
        const response = await this.bulkGetReactionsRaw(params, initOverrides);
        return await response.value();
    }

}
